import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';

import 'video.js/dist/video-js.css'

Vue.prototype.$http = http
Vue.prototype.common = common
Vue.prototype.$formatVndAmount = function (value) {
  if (value === null || value === undefined || value === '') {
    return value
  }

  const amount = String(value).trim()
  const sign = amount.charAt(0) === '-' ? '-' : ''
  const unsignedAmount = sign ? amount.slice(1) : amount
  const decimalSeparator = unsignedAmount.includes('.') ? '.' : unsignedAmount.includes(',') ? ',' : ''
  const parts = decimalSeparator ? unsignedAmount.split(decimalSeparator) : [unsignedAmount]
  const integer = parts[0]

  if (integer.length <= 3) {
    return sign + integer
  }

  return sign + integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(VueI18n);

const DEFAULT_LANG = 'yn_yu'
const storedLang = localStorage.getItem('lang')

if (!storedLang || storedLang === 'zh_cn') {
  
  localStorage.setItem('lang', DEFAULT_LANG)
}

const i18n = new VueI18n({
  globalInjection: true,
  locale: localStorage.getItem('lang') || DEFAULT_LANG,
  messages: {
    'yn_yu': require('./assets/languages/yn_yu.json'),
    'zh_cn': require('./assets/languages/zh_cn.json'),
    'en_us': require('./assets/languages/en_us.json'),
    'es_spa': require('./assets/languages/es_spa.json'),
    'ms_my': require('./assets/languages/ms_my.json'),
    'idn_yu': require('./assets/languages/idn_yu.json'),
    'ko_hy': require('./assets/languages/ko_hy.json'),
    'it_it': require('./assets/languages/it_it.json'),
    'de_de': require('./assets/languages/de_de.json'),
    'ja_jp': require('./assets/languages/ja_jp.json'),
    'ga_ie': require('./assets/languages/ga_ie.json'),
    'fr_fr': require('./assets/languages/fr_fr.json'),
    'nl_nl': require('./assets/languages/nl_nl.json'),
    'da_dk': require('./assets/languages/da_dk.json'),
    'no_no': require('./assets/languages/no_no.json'),
    'pt_pt': require('./assets/languages/pt_pt.json'),
    'sg_en': require('./assets/languages/en_us.json'),
    'cs_cz': require('./assets/languages/cs_cz.json'),
    'th_th': require('./assets/languages/th_th.json'),
  }
});

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
